import BasicLayout from '@/layouts/Basic';

const importEnv = require('./_import_' + process.env.NODE_ENV);
export default [
    {
        path: '/helpDoc/:id',
        component: BasicLayout,
        meta: {
            title: '帮助文档'
        },
        children: [
            {
                path: '',
                name: 'helpDoc',
                meta: {
                    allowNotLogin: true
                },
                component: importEnv('Docs/index')
            }
        ]
    }
];